import React from "react"
import tw, { styled } from "twin.macro"

const Header = ({ children, pre, post, ...props }) => (
  <Style role="banner" {...props}>
    {pre}
    <div className="site__column">{children}</div>
    {post}
  </Style>
)
export default Header

const Style = styled.header`
  ${tw`
        relative
        z-20
        lg:grid
        lg:grid-cols-12
        font-body
    `}

  box-shadow: 0 6px 3px -3px rgba(0,0,0,.05);

  nav {
    ${tw`ml-auto`}
  }

  > .site__column {
    ${tw`height[calc(var(--header-height) - 40px)] flex items-center justify-between container mx-auto w-full px-4`}
  }

  .brand {
    ${tw`xl:transform[translateY(3px)]`}
  }

  > .header__site-toggle {
    ${tw`col-start-1 col-span-6`}
  }

  > .header__aux-menu {
    ${tw`col-span-6 flex justify-end`}
  }

  > .site__column {
    ${tw`col-span-12`}
  }

  > .header__top {
    ${tw`col-start-1 col-span-12 container mx-auto flex justify-between items-center lg:mt-1`}
  }
`
